import { useQuery } from '@tanstack/react-query'
import { getFileContent } from '../api/data-connectors/get-file-content'

/**
 * Lazily fetches file content for preview. Only runs when `enabled` is true.
 */
export function useGetFileContent(fileId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['file-content', fileId],
    queryFn: () => getFileContent(fileId),
    enabled,
    staleTime: 300_000,
  })
}
